export const FASTSHIFT_LOCALSTORAGE_KEYS = {
	SELECTED_ORG_ID: 'fastshift-selected-org',
};

export const RESERVED_ORG_IDS = {
	NO_ORG: 'no-org',
	OTHER_ORGS: 'other-orgs',
} as const;

export type ReservedOrgIds = (typeof RESERVED_ORG_IDS)[keyof typeof RESERVED_ORG_IDS];

export const TABLE_IDS = {
	SELECTION: 'selection',
	MIGRATION_TICKETS: 'migrationTickets',
} as const;
